import React from 'react';
import tpl from '../templates/benefits-military-personnel';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            search_by: ['/services/benefits-military-personnel-conditions'],
            widgets_2: (ssrData && ssrData.widgets_2) || [],
            widgets_2_loading: !(ssrData && ssrData.widgets_2)
        };
    }

    componentDidMount() {
        super.componentDidMount();

        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/services/benefits-military-personnel-question',
            widgetKey: 'widgets_2'
        });
    }

    static displayName = 'BenefitsMilitaryPersonnel';
}
